import React from 'react';
import { useRegistration } from '../Registration';
import { useLanguage } from '../../../contexts/LanguageContext';

const Step3Introduction = () => {
  const { nextStep, prevStep } = useRegistration();
  const { t } = useLanguage();
  const copy = t('registration.steps.introduction', {});
  const highlights = Array.isArray(copy.highlights) ? copy.highlights : [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
          {copy.title}
        </h2>
      </div>

      {/* Welcome Content */}
      <div className="text-center space-y-6">
        <div className="bg-gradient-to-r from-prayer-red to-purple-600 text-white rounded-xl p-8">
          <div className="text-6xl mb-4">🙏</div>
          <h3 className="text-xl font-bold mb-4">{copy.hero?.title}</h3>
          <p className="text-white/90 leading-relaxed">
            {copy.hero?.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {highlights.map((item) => (
            <div key={item.title} className="bg-white border border-gray-200 rounded-lg p-6 text-left">
              <div className="text-3xl mb-3">{item.icon}</div>
              <h4 className="font-semibold text-gray-900 mb-2">{item.title}</h4>
              <p className="text-gray-600 text-sm">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-green-50 border border-green-200 rounded-lg p-6">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-green-800">{copy.nextSteps?.title}</h3>
              <p className="mt-1 text-sm text-green-700">
                {copy.nextSteps?.description}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-between pt-6">
        <button
          type="button"
          onClick={prevStep}
          className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-all duration-200"
        >
          {t('registration.previous')}
        </button>
        
        <button
          type="button"
          onClick={nextStep}
          className="px-6 py-3 bg-prayer-red text-white rounded-lg font-medium hover:bg-prayer-red-light transition-all duration-200"
        >
          {t('registration.next')}
        </button>
      </div>
    </div>
  );
};

export default Step3Introduction;
